import axiosWrapper from '../../axiosWrapper/axiosWrapper';
import {getAPICall, postAPICall} from '../../services/apiCallsHandler';
import {logError} from '../../utils/logger';

import axios from 'axios';

export const getAllOffersForMFACustomerUrl = (customerId) =>
  `/getMfaCustomerOffer?customerId=${customerId}`;

export const getOffersForNonMFACustomerUrl = (stateName, isCorporate) =>
  `/getNonMfaCustomerOffer?stateName=${stateName}&isCorporate=${isCorporate}`;

export const getOffersForNonMFACustomerByIdUrl = (offerId) =>
  `/getNonMfaCustomerOffer?offerId=${offerId}`;

export const getPersonalOfferLetterDataUrl = (customerId) =>
  `/personalizedOfferLetter?customerId=${customerId}`;

export const getUrlToSubmitMfaCustomerOffer = (customerId) =>
  `/submitMfaCustomerOffer?customerId=${customerId}`;

export const getUrlToSubmitRecommendedImplementOfferEnquiry = (customerId) =>
  `/submitImplementEnquiry?customerId=${customerId}`;

export const getUrlTononMFAOtp = (path) => {
  return `${process.env.REACT_APP_COMMUNICATION_API}/${path}`;
};

export const getprevouslySubmittedNonMFAoffersURL = () =>
  `/submittedNonMfaCustomerOffer`;

export const getDeviceTokenUrl = (customerId) =>
  `/deviceToken?customerId=${customerId}`;

export const getNonMfaUserProfileUrl = () => `/nonMfaUserProfile`;

export const updateNonMfaConsentUrl = () => `/updateNonMfaProfile`;

export const getAllOffersForMFACustomer = (url) => {
  return getAPICall(
    url,
    {
      isCallBack: true,

      errorTag: 'GET_ALL_OFFERS',
      logInfoMsg: 'load all offers for mfa customer',
      redirectToOops: false,
    },
    {}
  );
};

export const submitOfferEnquiryMFACustomer = () => {
  return Promise.resolve({success: 200});
};
export const getOfferDetailsJson = async (URL) => {
  return await axios.get(URL);
};

export const nonMfaOtpHelper = async (path, payload) => {
  return await axios.post(getUrlTononMFAOtp(path), payload);
};
